// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';

const schema = {
  $id: '/redebit-list-schema',
  type: 'object',
  required: ['id', 'creatorId', 'transactionId', 'amount'],
  nullable: true,
  properties: {
    id: {
      type: 'integer',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    creatorId: {
      type: 'integer',
    },
    creatorName: {
      type: 'string',
      nullable: true,
    },
    created: {
      type: 'string',
      format: 'date-time',
    },
    modifierId: {
      type: 'integer',
      nullable: true,
    },
    modifierName: {
      type: 'string',
      nullable: true,
    },
    modified: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    entryDate: {
      type: 'string',
      format: 'date-time',
    },
    transactionId: {
      type: 'integer',
    },
    debtorName: {
      type: 'string',
      nullable: true,
    },
    amount: {
      type: 'number',
    },
    currency: {
      type: 'string',
      nullable: true,
    },
    uploadStatus: {
      type: 'integer',
      nullable: true,
    },
    uploadStatusReportDownloadDate: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    paymentStatus: {
      type: 'string',
      nullable: true,
    },
    paymentStatusReportDownloadDate: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
